module.exports = __webpack_public_path__ + "img/mon_256.91d731bc.png";